export const EMAILJS_CONFIG = {
  PUBLIC_KEY: 'PnnQUWvySMMmxqNcR',
  SERVICE_ID: 'service_kairaly',
  CONTACT_TEMPLATE_ID: 'template_tdfllfh'
};